export default "__VITE_ASSET__1c88f2ee__"